import React, { useEffect, useState } from "react";
import { CONTACT } from "../mock/mock";

export default function WhatsAppButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const target = document.querySelector("#contact");

    // Reveal once the contact section scrolls into view.
    let observer;
    if (target) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) setShow(true);
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(target);
    }

    // Fallback: also reveal when the user reaches the bottom of the page.
    const onScroll = () => {
      const reachedEnd =
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 120;
      if (reachedEnd) setShow(true);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const digits = CONTACT.phone.replace(/[^\d]/g, "");
  const message = encodeURIComponent(
    "Bună ziua! Aș dori mai multe detalii despre serviciile Planimex."
  );
  const href = `https://wa.me/${digits}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactează-ne pe WhatsApp"
      className="group fixed bottom-6 right-6 z-[1200] flex items-center justify-center"
    >
      {/* radiant pulse ring — only active once the contact section is reached */}
      {show && (
        <span className="absolute inline-flex h-14 w-14 rounded-full bg-[#25D366] opacity-60 animate-ping" />
      )}
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#01B72C] shadow-[0_10px_30px_rgba(1,183,44,0.35)] transition-transform duration-300 group-hover:scale-105">
        <svg
          viewBox="0 0 32 32"
          width="30"
          height="30"
          fill="#ffffff"
          aria-hidden="true"
        >
          <path d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.463 1.712 6.404L3.2 28.8l6.57-1.723a12.74 12.74 0 006.233 1.586h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.052A12.72 12.72 0 0016.003 3.2zm0 23.02h-.004a10.6 10.6 0 01-5.4-1.48l-.387-.23-4.01 1.052 1.07-3.91-.252-.4a10.57 10.57 0 01-1.62-5.652c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.51 1.107 7.52 3.117a10.56 10.56 0 013.11 7.52c0 5.87-4.77 10.64-10.64 10.64zm5.83-7.96c-.32-.16-1.89-.933-2.184-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.57-1.586-.95-.848-1.592-1.895-1.778-2.215-.187-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.735-.986-2.375-.26-.624-.524-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.146 3.093 1.306 3.307.16.213 2.253 3.44 5.46 4.826.763.33 1.36.527 1.824.674.767.244 1.464.21 2.016.127.615-.092 1.89-.773 2.157-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z" />
        </svg>
      </span>
    </a>
  );
}
